export default __webpack_public_path__ + "static/media/blockGrayIcon.b61e6568.svg";